<template>
  <div>
    <Tag v-bind:key="item" v-for="item in items"> {{ item }} </Tag>
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      link: null,
    };
  },
  methods: {},
  created() {
    this.items = this.params.items(this.params.data);
  },
});
</script>

<style lang="scss" module>
.grid-select-input {
  width: 100%;
  height: 100%;
}
</style>
